import { useEffect, useState } from 'react';
import { getPublicPosts } from '../../lib/api';
import { siteIdentity } from '../../content/siteContent';
import { PostList } from '../components/PostList';
import type { CustomPage } from '../../lib/types';

export function BlogPage() {
  const [posts, setPosts] = useState<CustomPage[]>([]);

  useEffect(() => {
    getPublicPosts().then(setPosts).catch(() => setPosts([]));
  }, []);

  return (
    <section className="blog-page">
      <header className="page-hero">
        <p className="eyebrow">{siteIdentity.name}</p>
        <h1>Blog</h1>
      </header>
      <PostList posts={posts} />
    </section>
  );
}
